import script from "./newsAll.vue?vue&type=script&setup=true&lang=js"
export * from "./newsAll.vue?vue&type=script&setup=true&lang=js"

import "./newsAll.vue?vue&type=style&index=0&id=678e22ae&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-678e22ae"]])

export default __exports__